import { Button, useListContext } from "react-admin";
const btnStyle = { padding: ".5em 1em", margin: "2em 5em 2em 0" };
export const ClearFiltersButton = () => {
  const { setSort, setFilters } = useListContext();
  return (
    <>
      <Button
        label="Изчисти филтри"
        variant="contained"
        sx={btnStyle}
        onClick={() => {
          setFilters({});
        }}
      />
      <Button
        label="Изчисти сортиране"
        variant="contained"
        sx={btnStyle}
        onClick={() => {
          setSort({});
        }}
      />
    </>
  );
};
